import React from "react";

import { useField } from "@2po/formalizr";

type FormalizrHiddenFieldProps = {
    name: string;
};

const FormalizerHiddenField = ({ name }: FormalizrHiddenFieldProps) => {
    const [field, meta] = useField({ name });

    return (
        <input
            data-testid="form-hidden-input"
            name={field.name}
            type="hidden"
            value={meta.initialValue}
        />
    );
};

export default FormalizerHiddenField;
